import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "card-outlined pt-2 px-4 pb-4" }
const _hoisted_3 = { class: "text-center text-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第1条（総則） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("本利用規約は株式会社手塚宏二事務所（以下「当社」）と当社が提供する "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("「実践トレードラボ」を利用する者との間の基本的な事項を規定します。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第２条（定義） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("「本サービス」とは、当社が提供する「実践トレードラボ」 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("およびこれに付随・関連する全てのサービスをいいます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("「利用者」とは、本サービスを利用する個人(法人)をいいます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第３条（適用範囲） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("1. 本サービスを利用する者は、本利用規約に同意したものとみなします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2. 本利用規約は、本サービスの利用に関し、当社および利用者に対して適用されます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("3. 当社が本サービスに個別規定や追加規定を掲載する場合、それらは本利用規約の一部を構成するものとし、個別規定または追加規定が本利用規約と抵触する場合には、個別規定または追加規定が優先するものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("4. 本利用規約は、利用者の事前の承諾を得ることなく変更でき、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("利用者はこれを承諾するものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("変更後の利用規約は、特段の定めがない限り、変更日より適用されるものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ただし、利用者に大きな影響を与える場合には、あらかじめ合理的な事前告知期間を設けるものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("5. 本サービスからリンクされた他のサイトについては、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("そのサイトの利用規約等に同意のうえ、それに従ってご利用ください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第４条（料金および支払い） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("1. 本サービスの利用料は月額20,000円（税別）とします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("キャンペーン等によって特別料金を設定することがあります。その際は、販売ページをご確認ください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2. 利用者は本サービスの申込料を、当社が定めた期日までに支払うものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第５条（遵守事項） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("当社のサービスのご利用に際しては以下に定める行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（それらを誘発する行為や準備行為も含みます）を禁止いたします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("① 法令に違反する行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("② 当社による本サービスの提供を妨害する行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("③ 当社および本サービスの評価を落とす行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("④ 本サービスが提供するデータを第三者へ開示、無断転用または再販・再利用する行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("⑤ 本サービス提供の目的とは異なる目的で利用する行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("⑥ 他の利用者のＩＤ、パスワードを使用して本サービスを利用する行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("⑦ 手段のいかんを問わず他人からＩＤやパスワードを入手したり、他人にＩＤやパスワードを開示したり提供したりする行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("⑧ 本サービスに関連して、反社会的勢力に直接・間接に利益を提供する行為 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第６条（サービスの利用停止、ＩＤ削除） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("当社は、本サービスを適正に運営するために、以下の場合にはあらかじめ通知することなく、データやコンテンツを削除したり、本サービスの全部または一部の利用をお断りしたり、利用者のＩＤを削除したりするといった措置を講じることができるものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("① 利用者が本利用規約に定められている事項に違反した場合 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("② 当社にお支払いいただく利用料について支払の遅滞が生じた場合 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("③ ＩＤが反社会的勢力またはその構成員や関係者によって登録または使用された場合、もしくはそのおそれがあると当社が判断した場合 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("④ その他、利用者との信頼関係が失われた場合など、当社と利用者との契約関係の維持が困難であると当社が判断した場合 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第７条（免責） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("1. 本サービスは公表されているデータを基に作成しておりますが、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("その正確性、相当性、完全性などに対し当社は保証いたしません "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2. 天災地変、その他（通信トラブルなど）の不可抗力により、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("情報の全部または一部の提供の遅延または提供の不能を生じた場合には、当社はその責を負わないものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("3. 当社は、通信回線やコンピュータ等の障害によるシステムの中断もしくは遅滞、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("データの消失またはデータへの不正アクセス等により生じた損害または不利益、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("その他本サービスに関連して利用者または第三者に生じた損害または不利益について、一切責任を負わないものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("4. 本サービスは投資の勧誘や推奨を目的としたものではなく、利用者ご自身の判断と責任において利用するものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("5. 当社の故意または重大なる過失に基づく債務不履行の場合を除き、その請求原因の如何を問わず利用者の現実の損害、逸失利益その他の間接損害の賠償の責めにつき当社は一切の責任を負いません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("なお、利用者との本利用規約に基づく本サービスのご利用に関する契約が消費者契約法に定める消費者契約に該当する場合、上記の免責は適用されないものとし、当社は、当社の故意・重過失に起因する場合を除き、通常生じうる損害の範囲内で、かつ、当社が当該利用者より受領した利用料を上限として損害賠償責任を負うものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第８条（損害賠償） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("利用者が本利用規約に違反する行為または不正もしくは違法な行為によって当社に損害を与えた場合、当社は当該会員に対して蒙った一切の損害（訴訟費用および合理的範囲内の弁護士費用を含む。）について、賠償を求めることができるものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第９条（クーリングオフ） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("本サービスの利用につきクーリングオフ制度は適用されません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第１０条（知的財産権） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("本サービスに表示され、あるいは本サービスから取得できる全てのデータ、テキスト、情報およびその他の資料（以下「コンテンツ」）に関する著作権、商標権等の全ての権利（以下「知的財産権」）は、当社あるいは表示された会社の財産であり、著作権法等の知的財産権に関する法律等により保護されています。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("以下において利用者が当社に開示したコンテンツについて、当社は、利用者へ通知することなく、本サービスの提供または本サービスの広告、宣伝を目的として、全部または一部を自由に利用できるものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("・当社サイト "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("・当社主催のセミナーやアンケート "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("・当社への問い合わせやメッセージ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("・その他上記に類する媒体 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第１１条（契約・退会） 課金開始日より1ヶ月間とします。契約開始日に当社より会員サイトへの登録情報をメールで送信します。 当社及び利用者のいずれか一方が期間満了の30日前までに相手方に対し契約の更新の行わない通知をしない限り、本契約は引き続き1ヶ月同一条件で継続するもとし、以後も同様とします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（退会） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("退会希望の際は運営事務局へご連絡下さい。確認次第、利用停止の手続きを行います。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("契約期間終了の直前等、申請された日程によっては利用停止手続きが完了しない場合があります。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("利用者によるＩＤ・パスワードの紛失、その他利用者に帰すべき原因により退会ができない場合であっても、運営者は退会のために対応する義務はないものとし、利用者の利用料金の支払義務は当然に消滅するものではありません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（契約再開） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("契約再開を希望の際は、事務局へご連絡ください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("契約開始日に当社より会員サイトへの登録情報をメールで送信します。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第１２条（準拠法） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("本利用規約およびこれに関する一切の法律関係については、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("日本国法を準拠法とし、本利用規約は、日本国法に従って解釈されるものとします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第１３条（合意管轄） "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("本サービスに関連して、当社と利用者との間で問題が生じた場合、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("両者は誠意を持って協議するものとし、協議しても解決しない場合には "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2017年12月 制定 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2019年3月 一部改定 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2022年4月 一部改定 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_back_icon = _resolveComponent("base-back-icon")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createBlock(_component_layouts_auth_width, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_back_icon, { class: "mb-2" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('terms.labo')) + " " + _toDisplayString(_ctx.t('terms.title')), 1),
          _hoisted_4
        ])
      ])
    ]),
    _: 1
  }))
}